// @ts-strict

import { isArray, keys } from 'lodash';
import queryString from 'query-string';
import { FilterType } from '../models/core-models';

// Functions that can be used throughout the app

export function calculatePercentChange(baseNumber: number, compareNumber: number): number | '&infin' {
  if (baseNumber === 0) {
    if (compareNumber !== 0) {
      return '&infin';
    } else {
      return 0;
    }
  }
  return ((compareNumber - baseNumber) / baseNumber) * 100;
}

// function to diplay date with 0 if it's less than 10, eg. 9.2 will be displayed as 09.02
export function displayDateWithPrecedingZero(dateToCheck): number {
  return dateToCheck < 10 ? `0${dateToCheck}` : dateToCheck;
}

/**
 *
 * @param dateToCheck accepts date in format 'yyyy-mm-dd'
 * adds leading 0 if provided month or day is single digit
 * i.e. given date 2022-1-2 is returned as 2022-01-02
 */
export function checkDateFormat(dateToCheck: string): string {
  let date = dateToCheck;
  const dataArray = dateToCheck.split('-');
  if (dataArray.length === 3) {
    let month = dataArray[1];
    let day = dataArray[2];
    if (month.length === 1) {
      month = `0${month}`;
    }
    if (day.length === 1) {
      day = `0${day}`;
    }
    date = `${dataArray[0]}-${month}-${day}`;
  }
  return date;
}

/**
 *
 * @param params your parameters
 * @param ignoreList the array of filters (sort values in most cases) to filter from parameters
 */
export const getFilteredQueryParams = (params: FilterType, ignoreList: string[]) => {
  let nonMutableParams: FilterType = { ...params };

  ignoreList.forEach(ignoredParameter => {
    if (nonMutableParams[ignoredParameter] !== undefined) {
      delete nonMutableParams[ignoredParameter];
    }
  });

  nonMutableParams = Object.fromEntries(
    Object.entries(nonMutableParams).map(([key, value]) => {
      if (key.endsWith('[]')) {
        return [key.replace('[]', ''), value];
      }
      return [key, value];
    })
  ) as FilterType;

  return queryString.stringify(nonMutableParams, {
    arrayFormat: 'bracket-separator',
    arrayFormatSeparator: ',',
    skipNull: true,
    skipEmptyString: true
  });
};

export const parseQueryParams = (queryParams: string): FilterType => {
  const params = queryString.parse(queryParams, {
    arrayFormat: 'bracket-separator',
    arrayFormatSeparator: ',',
    parseNumbers: true
  });

  return Object.fromEntries(
    Object.entries(params).map(([key, val]) => {
      if (Array.isArray(val) && !key.endsWith('[]')) {
        return [key + '[]', val];
      }
      return [key, val];
    })
  ) as FilterType;
};

export const handleVerticalScrollOffset = (event: Event, offset = 50) => {
  if (event.target instanceof HTMLElement) {
    const elementHeight = event.target.offsetHeight;
    const scrollDistance = event.target.scrollHeight;
    const scrolledDistance = event.target.scrollTop;

    return scrollDistance - offset - (scrolledDistance + elementHeight) <= 0;
  }

  return false;
};
